import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "value"];
import { computed, ref } from 'vue';
import { ThemeIcon } from '../../index';
const __default__ = {
    inheritAttrs: false,
};
export default /*@__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'InputText', props: {
        type: {},
        modelValue: {},
        prependIcon: {},
        appendIcon: {}
    }, emits: ['update:modelValue'], setup(__props, { expose: __expose }) {
        const props = __props;
        const inputEl = ref();
        __expose({
            focus: () => {
                var _a;
                (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            },
        });
        const classes = computed(() => {
            return {
                'has--prepend': props.prependIcon,
                'has--append': props.appendIcon,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["formInputUI", classes.value])
            }, [
                _createElementVNode("input", _mergeProps({
                    ref_key: "inputEl",
                    ref: inputEl
                }, _ctx.$attrs, {
                    type: props.type,
                    value: _ctx.modelValue,
                    class: "formInput",
                    onInput: _cache[0] || (_cache[0] = ($event) => { var _a; return (_ctx.$emit('update:modelValue', (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.value)); })
                }), null, 16, _hoisted_1),
                (props.prependIcon)
                    ? (_openBlock(), _createBlock(_unref(ThemeIcon), {
                        key: 0,
                        class: "formInputIcon is--prepend",
                        name: props.prependIcon
                    }, null, 8, ["name"]))
                    : _createCommentVNode("", true),
                (props.appendIcon)
                    ? (_openBlock(), _createBlock(_unref(ThemeIcon), {
                        key: 1,
                        class: "formInputIcon is--append",
                        name: props.appendIcon
                    }, null, 8, ["name"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    } }));
